import '../../style/mobile/dashboard/M_Search.css';
import { RiSearch2Line } from "react-icons/ri";

const M_Search=()=>{
  return(
    <div className="m-search">
      <RiSearch2Line className="m-dash-search-icon"/>
      <input type="search" name="dash-search-input" id="m-dash-search-input" placeholder="جستجو..."/>
    </div>
  )
}

export default M_Search;